<template>
  <div
    class="vip-wrapper"
    v-zpm="{
      sectionid: 177,
      areaexposure: 177
    }"
  >
    <div class="vip-wrapper__content">
      <img :src="$setPicSize(userVipInfo.vipBannerPic)" alt="" />
      <span class="line"></span>
      <span class="vip-text"
        >会员本单预计可<span class="bold">再减{{ userVipInfo.vipBannerAmount / 100 }}元</span></span
      >
    </div>
    <span
      class="receive"
      :class="{ has_receive: userVipInfo.receiveStatus == 2 || userVipInfo.receiveStatus == 4 }"
      @click="showVipPoup"
      v-zpm="{
        sortname: userVipInfo.receiveStatusText,
        sortid: 0
      }"
      >{{ userVipInfo.receiveStatusText }}</span
    >

    <!-- vip领券弹窗 -->
    <z-popup v-model="isShowVipPopup" position="bottom" fix-top @click-overlay="close">
      <div
        class="popup-wrapper"
        :style="{
          backgroundImage: `url(${$setPicSize(userVipInfo.pic)})`
        }"
      >
        <img
          class="close"
          :src="
            $setPicSize(
              'https://pic1.zhuanstatic.com/zhuanzh/2aa83d21-5012-4abe-b011-55214d658f28.png',
              24,
              24
            )
          "
          alt=""
          @click="close"
        />
        <div class="price">
          <em>￥</em>
          <span>{{ userVipInfo.amount / 100 }}</span>
        </div>
      </div>
    </z-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Popup, Toast } from '@zz-common/zz-ui'
import { defineComponent, ref, onMounted, nextTick } from '@vue/composition-api'
import { loadFirstImage } from '@utils/index'
import { getReceiveRedBatch } from '@/apis'

Vue.use(Popup).use(Toast)

export default defineComponent({
  props: {
    userVipInfo: {
      type: Object,
      default: () => null
    }
  },

  setup(props, { emit }) {
    const isShowVipPopup = ref(false)
    onMounted(() => {
      loadFirstImage(props.userVipInfo?.pic)
      nextTick(() => {
        // 创建一个新的FontFace对象
        // 字体http请求耗时，大概一秒多，会有闪的过度，体验不好，因此提前加载字体文件
        const fontFace = new FontFace(
          'Alibaba-PuHuiTi-Heavy',
          'url("https://dl.zhuanstatic.com/fecommon/Alibaba-PuHuiTi-Heavy.ttf")'
        )
        // 加载字体
        fontFace
          .load()
          .then(() => {
            console.log('阿里字体文件已加载')
          })
          .catch((error) => {
            console.error('字体加载失败:', error)
          })
      })
    })

    const showVipPoup = async () => {
      const { redPlanId: planId, receiveStatus } = props?.userVipInfo
      // receiveStatus 0 未领取 1 已领取 2 已过期
      if (receiveStatus == 0) {
        const res = await getReceiveRedBatch({ planIds: planId }).catch((e) => {
          console.log(e)
        })
        const { msg, code } = res?.data
        if (code == 0) {
          isShowVipPopup.value = true
        } else {
          return Toast((msg && msg) || '领券失败，请稍后重试')
        }
      } else {
        isShowVipPopup.value = true
      }
    }
    const close = () => {
      if (props?.userVipInfo.receiveStatus == 0) {
        emit('updateBaseInfo')
      }
      isShowVipPopup.value = false
    }

    return {
      showVipPoup,
      isShowVipPopup,
      close
    }
  }
})
</script>
<style scoped lang="scss">
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.vip-wrapper {
  margin-top: 20px;
  width: 638px;
  height: 70px;
  background: url('https://pic1.zhuanstatic.com/zhuanzh/8d2d5492-2e0e-4f59-bd33-6a45de798e40.png')
    no-repeat top left;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-sizing: border-box;
  border-radius: 12px;
  position: relative;
  /deep/ .z-iphone-x {
    padding-bottom: 0 !important;
  }
  /deep/ .z-overlay {
    background-color: rgba(0, 0, 0, 0.5) !important;
  }
  &__content {
    display: flex;
    align-items: flex-end;
    font-size: 0;

    img {
      width: 130px;
      height: 24px;
    }
    .line {
      position: relative;
      height: 20px;
      margin: 0 10px;
      margin-right: 12px;
      &::after {
        @include hairline(#8a4b2a);
        border-left-width: 1px;
        margin-top: -4px;
      }
    }
    .vip-text {
      font-family: PingFang SC;
      font-weight: 300;
      font-size: 22px;
      line-height: 25px;
      color: #8a4b2a;
      font-style: normal;
      .bold {
        font-family: PingFang SC-Semibold;
        font-weight: 600;
      }
    }
  }
  .receive {
    display: inline-flex;
    align-items: center;
    padding: 0 18px;
    height: 36px;
    box-sizing: border-box;
    position: relative;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 22px;
    color: #8a4b2a;
    line-height: 72px;
    &::after {
      @include hairline(#8a4b2a);
      border-width: 1px;
      border-radius: 40px;
    }
    &.has_receive {
      color: #c39a81;
      &::after {
        @include hairline(#c39a81);
        border-width: 1px;
        border-radius: 40px;
      }
    }
  }
}

.popup-wrapper {
  height: 1122px;
  background-repeat: no-repeat;
  background-position: top left;
  background-size: 100% 100%;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 1);
    z-index: -1;
  }
  .close {
    height: 24px;
    width: 24px;
    position: absolute;
    top: 0;
    right: 0;
    margin-top: 52px;
    margin-right: 32px;
  }
  .price {
    margin-top: 399px;
    font-family: 'Alibaba-PuHuiTi-Heavy';
    font-weight: 900;
    font-size: 76px;
    color: #e5772a;
    line-height: 60px;
    text-shadow: inset 0 4px 5px rgba(176, 73, 0, 0.5);
    text-align: center;
    em {
      font-size: 48px;
      position: relative;
    }
  }
}
</style>
